/**
 * Genera un token seguro para invitación.
 * En Firestore guardamos solo el hash; el token plano se envía al candidato una vez.
 */
export function generateInviteToken(): string {
  const array = new Uint8Array(32);
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    crypto.getRandomValues(array);
  } else {
    for (let i = 0; i < 32; i++) array[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(array, (b) => b.toString(16).padStart(2, '0')).join('');
}

/**
 * Hash simple para no guardar el token en claro.
 * En producción podría usarse SHA-256 (subtle crypto).
 */
export async function hashToken(token: string): Promise<string> {
  if (typeof crypto !== 'undefined' && crypto.subtle) {
    const encoder = new TextEncoder();
    const data = encoder.encode(token);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
  }
  return token;
}

export function verifyTokenHash(token: string, storedHash: string): Promise<boolean> {
  return hashToken(token).then((h) => h === storedHash);
}
